import { render, staticRenderFns } from "./ProductCardSkeleton.vue?vue&type=template&id=f535a126&"
import script from "./ProductCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardSkeleton.vue?vue&type=style&index=0&id=f535a126&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports